import React from "react";

interface APRLoadNoticeViewProps {
  data: any;
}

const APRLoadNoticeView = ({ data }: APRLoadNoticeViewProps) => {
  return (
    <>
      <div className="row g-md-4 g-3 mb-4">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            {data?.custom_load_notice ? "Endframe Product" : "Endframe Type"}
          </label>
          <div className="mb-0 fs-6 fw-semibold d-block ">
            {data?.custom_load_notice
              ? data?.products?.[0]?.product_name
              : data?.variants?.[0]?.variant_name ?? "-"}
          </div>
        </div>
        {data?.custom_load_notice ? (
          <div className="col-lg-3 col-md-4 col-sm-6">
            <label className="custom-label mb-0 ff text-949494">
              Thickness
            </label>
            <div className="mb-0 fs-6 fw-semibold d-block ">
              {data?.products?.[0]?.thickness ?? "-"}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            1st Beam Level
          </label>
          <div className="mb-0 fs-6 fw-semibold d-block ">
            {data?.beam_level ?? "-"}
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            Largest Beam Pitch
          </label>
          <div className="mb-0 fs-6 fw-semibold d-block ">
            {data?.beam_pitch ?? "-"}
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            Maximum Load per Bay
          </label>
          <div className="mb-0 fs-6 fw-semibold d-block ">
            {data?.max_load_per_bay
              ? data?.max_load_per_bay > 0
                ? `${data?.max_load_per_bay}Kg`
                : "-"
              : "-"}
          </div>
        </div>
        {/* <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            Number of Beam Levels (G+)
          </label>
          <div className="mb-0 fs-6 fw-semibold d-block ">
            {data?.qty_beamlevels ?? "-"}
          </div>
        </div> */}
        {data?.custom_load_notice
          ? data?.products?.slice(1).map((product: any, idx: number) => {
              return (
                <>
                  <div className="col-lg-3 col-md-4 col-sm-6" key={idx}>
                    <label className="custom-label mb-0 ff text-949494">
                      Beam
                      {/*  {idx + 1} */}
                    </label>
                    <div className="mb-0 fs-6 fw-semibold d-block ">
                      {product?.product_name ?? "-"}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6">
                    <label className="custom-label mb-0 ff text-949494">
                      Beam Length
                      {/*  {idx + 1} */}
                    </label>
                    <div className="mb-0 fs-6 fw-semibold d-block ">
                      {product?.length ?? "-"}
                    </div>
                  </div>
                </>
              );
            })
          : ""}

        {data?.variants?.slice(1).map((variant: any, idx: number) => {
          return (
            <div className="col-lg-3 col-md-4 col-sm-6" key={idx}>
              <label className="custom-label mb-0 ff text-949494">
                Beam Level
                {/*  {idx + 1} */}
              </label>
              <div className="mb-0 fs-6 fw-semibold d-block ">
                {variant?.variant_name ?? "-"}
              </div>
            </div>
          );
        })}
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            Maximum Load per Level (UDL)
          </label>
          {data?.max_load_per_level?.length > 0 ? (
            data?.max_load_per_level?.map((item: any, idx: number) => (
              <div key={idx} className="mb-0 fs-6 fw-semibold d-block ">
                {item?.max_load} Kg
              </div>
            ))
          ) : (
            <div className="fs-6">-</div>
          )}
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-0 ff text-949494">
            Qty of Load Signs Required
          </label>
          <div className="mb-0 fs-6 fw-semibold d-block ">
            {data?.qty_loadsign ?? "-"}
          </div>
        </div>
      </div>
    </>
  );
};

export default APRLoadNoticeView;
